import { Component, Injector } from '@angular/core';
import { Alert } from './alert';
import { FilterComponent, FilterOptions, FilterBuilder, mapCollection, AuthorizationSchemeService, FilterProperty, toSentenceCase, AutocompleteDataSourceFn, MgAutocompleteData } from '@mango/core';

@Component({
	selector: 'dla-app-alert-filter',
	templateUrl: './alert-filter.component.html'
})
export class AlertFilterComponent extends FilterComponent<Alert> {
	constructor(
		injector: Injector) {
		super(injector, Alert, new FilterOptions<Alert>()
			.like("title")
			.like("message")

		);
	}

	ngOnInit() {
		super.ngOnInit();
	}
}